import { reducers } from '@spp/ui-core-navigation';

export const coreNavigationUI = reducers.coreNavigationUI;
export const spid = reducers.spid;



/** WEBPACK FOOTER **
 ** ./src/redux/reducers.js
 **/